import api from './api';

export interface AdminFeaturedGame {
  projectId: string;
  name: string;
  creatorName: string;
  thumbnailUrl?: string | null;
  videoUrl?: string | null;
  sortOrder: number;
  isPlayable: boolean;
}

export interface FeaturedGameCandidate {
  projectId: string;
  name: string;
  creatorName: string;
  thumbnailUrl?: string | null;
}

export async function getAdminFeaturedGames(): Promise<AdminFeaturedGame[]> {
  const response = await api.get<AdminFeaturedGame[]>('admin/featured-games');
  return response.data;
}

export async function searchFeaturedGameCandidates(search: string): Promise<FeaturedGameCandidate[]> {
  const response = await api.get<FeaturedGameCandidate[]>('admin/featured-games/candidates', {
    params: search ? { search } : undefined,
  });
  return response.data;
}

export async function addFeaturedGame(projectId: string): Promise<void> {
  await api.post('admin/featured-games', { projectId });
}

export async function reorderFeaturedGames(projectIds: string[]): Promise<void> {
  await api.put('admin/featured-games/order', { projectIds });
}

export async function uploadFeaturedGameVideo(projectId: string, file: File): Promise<AdminFeaturedGame> {
  const form = new FormData();
  form.append('file', file);
  const response = await api.post<AdminFeaturedGame>(`admin/featured-games/${projectId}/video`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function removeFeaturedGame(projectId: string): Promise<void> {
  await api.delete(`admin/featured-games/${projectId}`);
}
